(function() {
  angular.module('benefits')
  .controller('procedureModalController', ['$uibModalInstance',  '$uibModal', '$scope', '$filter',
     '$rootScope', 'uiGridConstants', 'gridServices','categoryInfo', 'benefitService','procedureCodeAuditUTS','showHistoryMessage','pdfPrintUtility','printBenefitsHelper',
    function($uibModalInstance, $uibModal, $scope, $filter,
      $rootScope, uiGridConstants, gridServices, categoryInfo, benefitService,procedureCodeAuditUTS,showHistoryMessage,printUtility,printHelper) {
      var vm = this;
      vm.authenticationChanged = false;
      vm.procedureCodeAuditUTS =getTimestamp(procedureCodeAuditUTS);
      vm.showHistoryMessage = showHistoryMessage;
      vm.categoryInfo = categoryInfo;
      vm.category = vm.categoryInfo.benefit;
      vm.category.planType = vm.categoryInfo.planType;
      benefitService.planSummaryPromise.then(function(data) {
        vm.planSummary = data;
      });
      if (vm.category.accumulators) {
        if (!vm.category.accumulators.id) {
          vm.category.accumulators.id = _.map(vm.category.accumulators,'id');
        }
      }
      vm.showNoAgeLimitMessage = false;
      vm.accumatorIndex = "P0";
      var orthoCategoryId = 26;
      if (vm.category &&
         (vm.category.coinsuranceInNetwork ||vm.category.coinsuranceOutNetwork || (vm.category.copayAmount != null))  &&
         (vm.category.id == orthoCategoryId || (vm.category.procedureCode >= 8000 && vm.category.procedureCode < 9000))) {
    	      var limitations = vm.category.limitations
              if(limitations &&
                (limitations["child"] && limitations["child"].max == 999)  &&
                (limitations["subscriber"] && limitations["subscriber"].max == 999) &&
                (limitations["spouse"] && limitations["spouse"].max == 999)){
            	  vm.showNoAgeLimitMessage = true;
              }
       }
      vm.category.inPlan = vm.category.coinsuranceInNetwork || vm.category.coinsuranceOutNetwork || (vm.category.copayAmount != null);
      vm.close = function() {
        $uibModalInstance.dismiss();
      };
      vm.model = {showInclusiveCodes: true};
      vm.gridOptions = {
        enableSorting: true,
        enableColumnResizing: true,
        enableRowHeaderSelection: false,
        exporterMenuPdf: false,
        enableGridMenu: true,
        gridMenuShowHideColumns: false,
        columnDefs: [
          { field: 'code', displayName: 'Procedure Code', cellFilter: 'procedureCode', enableHiding: false,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 1
            }
          },
          { field: 'toothNumber', displayName: 'Tooth/Quadrant', enableHiding: false,headerTooltip: 'Tooth/Quadrant'},
          { field: 'surfaces',  displayName: 'Surfaces' ,enableHiding: false,headerTooltip: 'Surfaces'},
          { field: 'description', enableHiding: false},
          { field: 'serviceDate', displayName: 'Date Of Service', cellFilter: 'portalDate', enableHiding: false,
            sort: {
              direction: uiGridConstants.DESC,
              priority: 0
            },
            sortingAlgorithm: gridServices.dateSort(vm, (row) => row.serviceDate),
          }
        ],
        onRegisterApi: function(api) {
          vm.gridApi = api;
        }
      };

      $scope.$on('authenticationChanged', () => {
        vm.authenticationChanged = true;
        $uibModalInstance.dismiss();
      });

      $scope.$watch('vm.model.showInclusiveCodes', (showOrHide) => {
          displayProcHistory(showOrHide);
      });

      $scope.$on('modal.closing', function(event, reason, closed) {
        if (vm.authenticationChanged) {
          printHelper.initPrintableProdedureCodes();
        }else{
        	
          let procedureHistory = printUtility.getPrintableUiGrid('grid')['Grid'];
          let accumulatorInfo = printUtility.getPrintableTable('accumulator' + vm.accumatorIndex)['Accumulator' + vm.accumatorIndex];
          let printableProcedureCode = _.merge({},
                                               printUtility.getPrintableTextByIds(['codeDescription','reviewWarning','coverageStatus','dentalNetWarning']),
                                               printUtility.getPrintableDescriptionList('procCodeSummary'),
                                               accumulatorInfo ? {'AccumulatorInfo': accumulatorInfo } : {},
                                               procedureHistory ? {'ProcedureHistory': procedureHistory} : {}
                                              );
          printHelper.printableProcedureCodes($filter('procedureCode')(vm.categoryInfo.benefit.procedureCode), printableProcedureCode);
       }
      });

      benefitService.procedureHistoryPromise.then((procedures) => {
        vm.procHistory = procedures.data;
        displayProcHistory(vm.model.showInclusiveCodes);
      });

      function displayProcHistory(showInclusive) {
        if(vm.procHistory.length) {
          if(!showInclusive) {
            vm.gridOptions.data = $filter('filter')(vm.procHistory, {code: vm.category.procedureCode});
          } else {
            if (vm.category) {			  
			  let relatedProcedures = vm.category.limitations.procedures ? vm.category.limitations.procedures : [];
			  let primaryRule = $filter('primaryFrequencyRule')(vm.category.limitations);
			  if (primaryRule && primaryRule.procedures) { 		  
			  	  relatedProcedures = primaryRule.procedures;
			  }			  
              vm.gridOptions.data = $filter('showInclusiveCodes')(vm.procHistory,
                vm.category.procedureCode, relatedProcedures );
            }
          }
        }
      }
      function getTimestamp(date) {
          let d = new Date(date).getTime();
          let tzOffset = new Date().getTimezoneOffset() * 60 * 1000;
          return $filter('date')(d - tzOffset, 'M/d/yy h:mm a');
      }
    }]);
})();
